/* ============================================================================
   RENKEISEN · rk-global.js
   Sistema global de conversion. Cargar con defer, en todas las plantillas.

     0. Puente del carro: traduce cartUpdate de Dawn a rk:carro
     1. Barra de progreso de scroll
     2. Toggle de modo de pago
     3. Countdown de corte en la barra de anuncio
     4. Carro del encabezado: contador y acuse de recibo

   Todo lo que se mueve pregunta primero por prefers-reduced-motion.
============================================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raiz = document.documentElement;

  /* AQUI NO SE FORMATEA NINGUN MONTO, y es deliberado.
     Hubo una copia de la funcion de formateo en estas lineas. Estaba MUERTA:
     ninguna linea del archivo la llamaba, habia nacido por analogia con
     rk-ui.js. Eso explica por que las tres apariciones del mismo bug —el
     importe que sale cien veces mas grande porque Shopify guarda los montos
     en centavos— se arreglaron siempre en un solo archivo: la segunda copia
     no se ejecutaba, solo esperaba a que alguien la usara.
     Se reemplazo por un delegador con respaldo, y tampoco: un respaldo que
     nadie ejecuta es una segunda formula que puede divergir sin que ninguna
     corrida lo delate, que es justo el mecanismo que esto viene a cerrar.
     Este archivo no imprime dinero: el bloque 2 copia cadenas ya formateadas
     desde data-cod y data-pre, el 3 imprime una hora y el 4 un conteo.
     El dia que haga falta un importe aqui, se llama a window.rkFormato.monto,
     que es el dueño unico y vive en el bloque 0 de rk-ui.js. Sin copias. */

  /* ==========================================================================
     0 · PUENTE DEL CARRO
     TODA mutacion del carro tiene que hablar un solo idioma.

     EL DEFECTO QUE CIERRA. Habia dos canales vivos y ninguno sabia del otro:

       rk:carro          evento de DOM. Lo emitia UNICAMENTE el agregado por
                         AJAX de rk-ui.js, y es el unico que escuchan el
                         contador del encabezado (bloque 4) y el reacomodo del
                         dock (bloque 1).
       cartUpdate        canal de Dawn. Lo publica cart.js en CADA cambio de
                         cantidad y en CADA eliminacion, y lo escucha el panel
                         de decision de rk-ui.js.

     Consecuencia medida el 21-08-2026 en 390px: carro con dos lineas, se
     elimina una, el carro real queda en 1 articulo y la insignia se queda en
     2. Lo mismo al pulsar "+": real 3, insignia 2. El panel de decision si se
     actualizaba, porque escucha el otro canal, asi que la cabecera y el panel
     mostraban dos verdades distintas del mismo carro en la misma pantalla.

     POR QUE UN PUENTE Y NO UN SEGUNDO OYENTE EN LA INSIGNIA. Suscribir el
     bloque 4 a cartUpdate lo arreglaba para la insignia y dejaba al dock con
     el mismo agujero, y el proximo consumidor de rk:carro naceria roto otra
     vez. Traducir una sola vez, en la entrada, deja UN evento interno y UN
     escritor de la insignia, que sigue siendo el bloque 4.

     LA DEDUPLICACION NO ES COSMETICA. El agregado de rk-ui.js emite los dos
     avisos por el mismo hecho: primero rk:carro y despues cartUpdate. Sin
     memoria, este puente reemitiria el segundo y la insignia repintaria dos
     veces el mismo numero, reiniciando su animacion de salto a mitad de
     camino. Por eso escucha tambien rk:carro: para saber que ese conteo ya se
     anuncio, venga de donde venga.
  ========================================================================== */
  (function () {
    var ultimo = null;

    /* El estado de partida se aprende del marcado y no de una constante: la
       insignia nace escrita por Liquid con el conteo real de la sesion. */
    var b0 = document.querySelector('[data-rk-cart-badge]');
    if (b0) {
      var n0 = parseInt(b0.textContent, 10);
      if (!isNaN(n0)) { ultimo = n0; }
    }

    /* Se registra ANTES de emitir nada, y escucha su propio evento a
       proposito: asi el puente se entera igual de los avisos que no salieron
       de el, que son los del agregado de rk-ui.js. */
    document.addEventListener('rk:carro', function (ev) {
      if (ev.detail && typeof ev.detail.count === 'number') { ultimo = ev.detail.count; }
    });

    var avisar = function (n) {
      if (typeof n !== 'number' || isNaN(n) || n === ultimo) { return; }
      ultimo = n;
      document.dispatchEvent(new CustomEvent('rk:carro', { detail: { count: n } }));
    };

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS.cartUpdate) { return; }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      /* Camino normal: cart.js publica el carro entero ya parseado. */
      if (ev && ev.cartData && typeof ev.cartData.item_count === 'number') { avisar(ev.cartData.item_count); return; }
      /* Respaldo para cualquier emisor que avise sin adjuntar el estado. Se
         pregunta por el carro real en vez de suponer un delta: es una lectura
         mas, y la alternativa es una insignia inventada. */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { avisar(c.item_count); })
        .catch(function () {});
    });
  })();

  /* ==========================================================================
     1 · BARRA DE PROGRESO
     Se anima con transform:scaleX y no con width, para que la resuelva el
     compositor sin recalcular layout en cada cuadro de scroll. La lectura de
     scrollY va dentro de requestAnimationFrame para no forzar reflujos
     sincronicos mientras el dedo arrastra.
  ========================================================================== */
  (function () {
    var barra = document.querySelector('[data-rk-progreso] i');
    if (!barra) return;
    var pendiente = false;
    var pintar = function () {
      pendiente = false;
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var p = alto > 0 ? Math.min(window.scrollY / alto, 1) : 0;
      barra.style.transform = 'scaleX(' + p + ')';
    };
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(pintar);
    }, { passive: true });
    pintar();
  })();

  /* ==========================================================================
     1b · EL DOCK SE APARTA DE LOS BOTONES DE COMPRA

     El dock es un control global y vive fijo abajo. Cualquier posicion fija en
     el borde inferior termina tapando algo: centrado cubria la columna de
     decision de la ficha, y movido a la izquierda cubria el boton primario de
     la pagina de ofertas. No hay una esquina buena, porque las paginas no
     ponen su CTA en el mismo sitio.

     Asi que en vez de elegir una esquina, el dock cede el paso. Se comprueba
     su rectangulo contra el de cada boton de compra visible y, si se solapan,
     se retira hacia abajo. Vuelve solo en cuanto deja de estorbar.

     Se mide con getBoundingClientRect y no con IntersectionObserver porque lo
     que importa es el solape real entre dos cajas, no si un elemento entro en
     una franja: el dock cambia de sitio segun el ancho y la franja habria que
     recalcularla en cada resize. Con seis botones como maximo, medir cuesta
     menos que mantener esa franja al dia.
  ========================================================================== */
  (function () {
    var dock = document.querySelector('.rk-modo-dock');
    if (!dock) return;

    /* .rk-btn--pri y .rk-btn--sec entran tarde y por un fallo concreto: el
       estado vacio de la pagina de ofertas usa esas clases, no .rk-btnf--pri,
       y el dock se quedaba fijo justo encima de la unica accion de esa
       pantalla. Lo mismo pasaba en los cierres de rk-404, rk-carro-decision,
       rk-catalogo, rk-hero-prisma y rk-reglas. */
    var SELECTOR = '[data-rk-cta], .rk-ctas a, .rk-riel__btn, .rk-btnf--pri, .rk-btn--pri, .rk-btn--sec, [data-rk-agregar]';
    var botones = [];
    var refrescar = function () { botones = Array.prototype.slice.call(document.querySelectorAll(SELECTOR)); };
    refrescar();
    if (!botones.length) return;

    var HOLGURA = 10;   /* aire minimo entre el dock y un boton */
    var pendiente = false;

    var revisar = function () {
      pendiente = false;
      /* Se mide con el dock en su sitio: si esta retirado, su rectangulo ya no
         dice donde estorbaria, asi que se consulta la posicion de reposo. */
      var oculto = dock.classList.contains('is-aparte');
      if (oculto) dock.classList.remove('is-aparte');
      var d = dock.getBoundingClientRect();
      var alto = window.innerHeight, ancho = window.innerWidth;

      var choca = false;
      for (var i = 0; i < botones.length; i++) {
        var r = botones[i].getBoundingClientRect();
        if (r.width < 4 || r.height < 4) continue;
        if (r.bottom < 0 || r.top > alto || r.right < 0 || r.left > ancho) continue;
        if (r.top - HOLGURA < d.bottom && r.bottom + HOLGURA > d.top &&
            r.left - HOLGURA < d.right && r.right + HOLGURA > d.left) { choca = true; break; }
      }
      dock.classList.toggle('is-aparte', choca);
    };

    var pedir = function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(revisar);
    };

    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', function () { refrescar(); pedir(); });
    /* El contenido que aparece despues (cross-sell, respuesta del carro) puede
       traer botones nuevos; se vuelve a leer la lista antes de medir. */
    document.addEventListener('rk:carro', function () { refrescar(); pedir(); });
    setTimeout(function () { refrescar(); revisar(); }, 600);
    revisar();
  })();

  /* ==========================================================================
     2 · TOGGLE DE MODO DE PAGO
     Cambia todos los precios visibles entre "pagas al recibir" y "pagas ahora
     con 10% menos".

     LA INVARIANTE QUE SOSTIENE TODO ESTO
     Un toggle que solo cambia el texto del precio es una trampa: el cliente
     ve $71.091, pulsa comprar, y el checkout le cobra $78.990. Ese es
     exactamente el supuesto que persigue la Ley 19.496. Por eso el modo no
     cambia solo la cifra: cambia tambien el DESTINO de cada boton de compra.

       modo pre  ->  el boton primario pasa por /discount/PAGOAHORA?redirect=...
                     o por el permalink /cart/<variante>:1?discount=PAGOAHORA
       modo cod  ->  el boton primario vuelve a la ruta sin cupon

     Un boton de compra que no declare sus dos rutas con data-url-cod y
     data-url-pre NO se toca: se prefiere no cambiarle el destino antes que
     mandarlo a una ruta equivocada. Los dos botones del par de compra las
     declaran iguales, porque su etiqueta nombra la ruta y moverlos seria
     mentirles; ahi la relacion se invierte y es el clic el que fija el modo.

     ESTE BLOQUE ES EL DUENO DEL MODO, y el unico.
       window.rkModo(modo)          lo cambia desde cualquier otra pantalla
       evento 'rk:modo' en document avisa a quien tenga que repintarse
     Quien escuche el evento no debe volver a llamar a window.rkModo: el
     sentido de escritura es uno solo y asi no hay forma de armar un circulo.

     El estado vive en localStorage y se aplica en <head> con un script en
     linea, antes de pintar, para que el precio no parpadee de un valor al
     otro al cargar la pagina.
  ========================================================================== */
  var MODO_CLAVE = 'rk.modo';

  /* SOLO PAGO EN LINEA (ajuste del tema, 12-09-2026). Con una sola forma de
     pago no hay modo que elegir: Liquid ya imprime el precio de lista, que es
     el que se cobra, y ya no imprime ningun texto de contra entrega. El modo
     queda fijo en "cod" solo porque ese es el estado que muestra el precio de
     lista, y este bloque NO vuelve a escribir en la pagina: su observador de
     mutaciones reescribiria con los valores impresos al cargar cifras que otro
     bloque ya actualizo, como el subtotal del carro. */
  var SOLO = raiz.hasAttribute('data-rk-solo');

  /* Ultimo modo realmente aplicado. Existe solo para no volver a avisar al
     resto del tema cuando el observador de mas abajo re-aplica el mismo modo
     sobre contenido recien insertado: sin esto, cada mutacion del DOM
     terminaria repintando la pantalla de decision del carro. */
  var modoVigente = null;

  var leerModo = function () {
    if (SOLO) { return 'cod'; }
    try { return localStorage.getItem(MODO_CLAVE) === 'pre' ? 'pre' : 'cod'; }
    catch (e) { return 'cod'; }
  };

  var aplicarModo = function (modo, animar) {
    raiz.dataset.rkModo = modo;
    if (SOLO) { return; }

    /* --- precios --- */
    var nodos = document.querySelectorAll('[data-cod][data-pre]');
    for (var i = 0; i < nodos.length; i++) {
      var n = nodos[i];
      var txt = modo === 'pre' ? n.getAttribute('data-pre') : n.getAttribute('data-cod');
      if (txt === null || n.textContent === txt) continue;
      n.textContent = txt;
      if (animar && !reduce) {
        n.classList.remove('rk-flip');
        /* forzar reflujo para poder relanzar la misma animacion */
        void n.offsetWidth;
        n.classList.add('rk-flip');
      }
    }

    /* --- glosas que acompañan a un precio --- */
    var glosas = document.querySelectorAll('[data-cod-t][data-pre-t]');
    for (var g = 0; g < glosas.length; g++) {
      var el = glosas[g];
      var t = modo === 'pre' ? el.getAttribute('data-pre-t') : el.getAttribute('data-cod-t');
      /* Se compara antes de escribir, igual que con los precios. Asignar
         textContent reemplaza el nodo de texto aunque la cadena sea la misma,
         y eso es una mutacion que despierta al observador de mas abajo, que
         vuelve a aplicar el modo: sin esta comparacion el par se llamaba a si
         mismo en cada cuadro. */
      if (t === null || el.textContent === t) continue;
      el.textContent = t;
    }

    /* --- destino de los botones de compra: la invariante --- */
    var botones = document.querySelectorAll('[data-url-cod][data-url-pre]');
    for (var b = 0; b < botones.length; b++) {
      var bt = botones[b];
      var url = modo === 'pre' ? bt.getAttribute('data-url-pre') : bt.getAttribute('data-url-cod');
      if (url) bt.setAttribute('href', url);
    }

    /* --- estado visual del dock ---
       button[data-rk-modo] y no [data-rk-modo] a secas. Este mismo bloque
       escribe data-rk-modo en el <html> unas lineas mas arriba, para que el
       CSS pueda reaccionar al modo sin esperar al JavaScript, asi que el
       selector suelto tambien alcanza al <html>: le colgaba un aria-pressed,
       que ahi no significa nada, y una clase is-activo que cualquier regla
       podria pescar por accidente. */
    var btns = document.querySelectorAll('button[data-rk-modo]');
    for (var k = 0; k < btns.length; k++) {
      var activo = btns[k].getAttribute('data-rk-modo') === modo;
      btns[k].classList.toggle('is-activo', activo);
      btns[k].setAttribute('aria-pressed', activo ? 'true' : 'false');
    }

    /* --- la ficha tiene su propio control; se mantienen sincronizados --- */
    var opts = document.querySelectorAll('[data-rk-opt]');
    for (var o = 0; o < opts.length; o++) {
      var esta = opts[o].getAttribute('data-rk-opt') === (modo === 'pre' ? 'prepago' : 'cod');
      opts[o].classList.toggle('is-elegida', esta);
      var radio = opts[o].querySelector('input[type="radio"]');
      if (radio) radio.checked = esta;
    }

    /* --- aviso al resto del tema --- */
    /* Marcar el radio no alcanza: la pantalla de decision del carro (bloque 4
       de rk-ui.js) ademas del destino cambia el texto del boton primario y
       revela u oculta el formulario de contra entrega, y asignar .checked por
       codigo no dispara ningun evento. Sin este aviso las dos piezas mandaban
       sobre la misma pantalla sin hablarse: el subtotal grande mostraba el
       neto del prepago mientras el boton iba al formulario que cobra el
       total. Se avisa solo cuando el modo cambia de verdad, y quien escuche
       no debe volver a llamar aca: el sentido de escritura es uno solo. */
    if (modo !== modoVigente) {
      modoVigente = modo;
      document.dispatchEvent(new CustomEvent('rk:modo', { detail: { modo: modo } }));
    }
  };

  var guardarModo = function (modo) {
    if (SOLO) { return; }
    try { localStorage.setItem(MODO_CLAVE, modo); } catch (e) {}
  };

  /* Unica puerta de entrada para el resto del tema. Cualquier pantalla con su
     propio selector de pago escribe aca en vez de llevar una copia del estado:
     el precio visible y el destino del boton salen siempre del mismo dato. */
  window.rkModo = function (modo, animar) {
    modo = modo === 'pre' ? 'pre' : 'cod';
    guardarModo(modo);
    aplicarModo(modo, animar !== false);
    return modo;
  };
  window.rkModo.leer = leerModo;

  /* El dock */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    /* button[data-rk-modo], y el "button" no es cosmetico: sin el, este
       manejador se comia TODOS los clics del sitio y dejaba muerto el bloque
       de mas abajo.
       El motivo es que aplicarModo escribe data-rk-modo en el <html> para que
       el CSS pueda reaccionar antes de que corra el JavaScript. closest() sube
       por los ancestros hasta la raiz, asi que cualquier clic en cualquier
       parte de la pagina encontraba el <html>, re-aplicaba el modo que ya
       estaba puesto y hacia return. Consecuencia: pulsar "Pedir contra
       entrega" no cambiaba el modo, porque el manejador de [data-rk-cta] nunca
       llegaba a ejecutarse, y la pagina seguia mostrando el neto del prepago
       mientras el cliente entraba al formulario que cobra el total. Es
       exactamente el agujero que [data-rk-cta] existe para tapar, tapado a su
       vez por un selector demasiado ancho.
       Detectado el 21-08-2026 midiendo el dock: el barrido conto tres
       [data-rk-modo] donde el marcado solo emite dos. */
    if (SOLO) return;
    var btn = t.closest('button[data-rk-modo]');
    if (btn) {
      var modo = btn.getAttribute('data-rk-modo');
      guardarModo(modo);
      aplicarModo(modo, true);
      return;
    }

    /* El par de botones de compra va en el otro sentido, y es a proposito.
       Cada uno NOMBRA su ruta en la etiqueta ("Pagar ahora y ahorrar 10%",
       "Pedir contra entrega"), asi que repuntarlos segun el modo los haria
       mentir: el naranjo prometeria el descuento y aterrizaria en el
       formulario que cobra el total. Lo que sigue al boton es el modo.
       Asi se cierra el hueco reportado: en modo pre la ficha mostraba
       $71.091 y quien pulsaba "Pedir contra entrega" llegaba a Releasit, que
       cobra $78.990. Ahora la pagina pasa a mostrar el precio de la puerta en
       el mismo clic, antes de que el cliente llene una sola casilla. */
    var cta = t.closest('[data-rk-cta]');
    if (!cta) return;
    var modoCta = cta.getAttribute('data-rk-cta') === 'prepago' ? 'pre' : 'cod';
    guardarModo(modoCta);
    aplicarModo(modoCta, true);
  });

  /* Entre pestañas abiertas del mismo sitio */
  window.addEventListener('storage', function (ev) {
    if (ev.key === MODO_CLAVE) aplicarModo(leerModo(), true);
  });

  /* Contenido que aparece despues: respuesta del carro, editor de temas.
     Se re-aplica el modo en vez de dejar precios a medio camino. */
  if ('MutationObserver' in window && !SOLO) {
    var pendienteMo = false;
    var mo = new MutationObserver(function () {
      if (pendienteMo) return;
      pendienteMo = true;
      requestAnimationFrame(function () {
        pendienteMo = false;
        aplicarModo(leerModo(), false);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  aplicarModo(leerModo(), false);

  /* ==========================================================================
     3 · COUNTDOWN DE CORTE EN LA BARRA DE ANUNCIO
     Cuanto falta para el corte de despacho del dia. NO se calcula en Liquid
     porque Shopify cachea el HTML y la hora quedaria congelada en el momento
     del render: el sitio podria prometer "despacho hoy" a las once de la
     noche. Se resuelve en el navegador y contra la hora de SANTIAGO, no la
     local del visitante, porque el corte es de la bodega.
     Nace oculto: si algo falla no se muestra ninguna promesa, en vez de una
     equivocada.
  ========================================================================== */
  (function () {
    var chip = document.querySelector('[data-rk-corte-chip]');
    if (!chip) return;
    var horaCorte = parseInt(chip.getAttribute('data-rk-corte-chip'), 10) || 18;

    var pintar = function () {
      try {
        var partes = new Intl.DateTimeFormat('es-CL', {
          timeZone: 'America/Santiago', hour: 'numeric', minute: 'numeric',
          weekday: 'short', hour12: false
        }).formatToParts(new Date());
        var h = 0, m = 0, dia = '';
        partes.forEach(function (p) {
          if (p.type === 'hour') h = parseInt(p.value, 10);
          if (p.type === 'minute') m = parseInt(p.value, 10);
          if (p.type === 'weekday') dia = p.value.toLowerCase();
        });
        var finde = dia.indexOf('sá') === 0 || dia.indexOf('sab') === 0 || dia.indexOf('dom') === 0;

        if (finde) {
          chip.textContent = 'DESPACHO EL LUNES';
        } else if (h < horaCorte) {
          var falta = (horaCorte - h) * 60 - m;
          var hh = Math.floor(falta / 60), mm = falta % 60;
          chip.textContent = 'DESPACHO HOY · PIDE EN ' +
            (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm;
        } else {
          chip.textContent = 'DESPACHO MAÑANA A PRIMERA HORA';
        }
        chip.hidden = false;
      } catch (e) {
        /* Se deja el respaldo estatico que trae el marcado. Antes esto dejaba
           el chip oculto, y revelarlo mas tarde empujaba el documento entero:
           0,194 de CLS en movil. Ahora el hueco ya esta reservado y un fallo
           de calculo simplemente no reemplaza el texto. */
      }
    };

    pintar();
    setInterval(pintar, 30000);
  })();

  /* ==========================================================================
     4 · CARRO DEL ENCABEZADO
     Mantiene el contador al dia y da acuse de recibo visible al agregar.
     El evento lo dispara quien agrega (la ficha, una tarjeta de catalogo o el
     riel movil) con
       document.dispatchEvent(new CustomEvent('rk:carro', {detail:{count}}))

     ESTE BLOQUE SOLO ESCUCHA, y tiene que seguir asi. Agregar al carro lo
     resuelve el bloque 7 de rk-ui.js sobre [data-rk-agregar], y es la unica
     implementacion. Aca vivia una segunda, completa, colgada de
     [data-rk-add]: un gancho que ningun archivo del tema emitia y que se
     leia como una abreviatura razonable del vivo. Bastaba que alguien lo
     escribiera por analogia para que los dos manejadores atendieran el mismo
     clic y el producto entrara dos veces al carro. No devolver ese manejador
     aca: si hace falta tocar el agregado, se toca en rk-ui.js.
  ========================================================================== */
  (function () {
    var badge = document.querySelector('[data-rk-cart-badge]');
    var icono = document.querySelector('[data-rk-cart-icono]');

    var pintar = function (n) {
      if (!badge) return;
      badge.textContent = n;
      badge.setAttribute('data-vacio', n > 0 ? '0' : '1');
      if (reduce) return;
      badge.classList.remove('rk-cart-salta');
      void badge.offsetWidth;
      badge.classList.add('rk-cart-salta');
      if (icono) {
        icono.classList.remove('rk-cart-pulsa');
        void icono.offsetWidth;
        icono.classList.add('rk-cart-pulsa');
      }
    };

    document.addEventListener('rk:carro', function (ev) {
      if (ev.detail && typeof ev.detail.count === 'number') pintar(ev.detail.count);
    });
  })();

  /* ---------- 5b. EL CUPON DE PREPAGO NO SE QUEDA EN EL CARRO ----------

     LO QUE PASABA. Basta que alguien mire el pago con tarjeta una vez y
     vuelva atras: PAGOAHORA se queda aplicado al carro y desde ese momento el
     formulario de CONTRA ENTREGA cobra el 10% menos. Medido: el boton que el
     cliente acaba de pulsar promete $59.800 y el formulario que se abre
     debajo dice Total $53.820. La tienda regala el descuento de tarjeta en
     pedidos en efectivo, y ademas se contradice en la misma pantalla.

     POR QUE SE LIMPIA AL CARGAR Y NO AL ELEGIR CONTRA ENTREGA. El formulario
     de Releasit se monta con la pagina, no cuando se revela: si se limpiara
     en el clic, el formulario ya habria leido el total con descuento y
     seguiria mostrandolo. Limpiando al cargar, nace con la cifra correcta.

     Y NO SE PIERDE NADA: el descuento no vive en el carro por derecho propio,
     lo pone el enlace de prepago (/discount/PAGOAHORA?redirect=...) en el
     momento de ir a pagar con tarjeta. Quien elija tarjeta lo vuelve a
     aplicar el, en esa misma navegacion.

     QUE BORRA Y QUE NO. Se probaron cuatro caminos contra la tienda real:
       /discount/ vacio                 no lo borra
       /discount/<codigo-inexistente>   no lo borra
       atributos del carro              no lo borra
       POST /cart/update.js discount:"" LO BORRA   <- este
     Solo quita el CODIGO. El descuento automatico del cepillo es de linea y
     no se toca: el carro vuelve de $53.820 a $59.800, no a $69.800. */
  (function () {
    var raizR = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };

    /* SOLO SE LIMPIA EN MODO CONTRA ENTREGA, y esto no es un detalle: la
       primera version limpiaba siempre y borraba el cupon justo al cliente
       que acababa de elegir tarjeta. Medido: llegaba al carro por
       /discount/PAGOAHORA?redirect=/cart y salia con descuento $0, o sea el
       arreglo se comia el 10% que el cliente si habia ganado.
       El modo lo escribe el guion en linea de theme.liquid antes del primer
       pintado, asi que aqui ya esta decidido. Ante la duda NO se limpia:
       cobrar de menos se arregla, borrarle el descuento a quien lo eligio se
       traduce en un carro abandonado. */
    var modo = (document.documentElement.dataset || {}).rkModo;
    if (modo === 'pre') { return; }

    /* SEGUNDA GUARDA, y hace falta por un choque entre dos arreglos propios.
       En movil el modo se fuerza a contra entrega al cargar, porque el dock
       que permitia cambiarlo ya no se dibuja ahi; asi que la guarda de arriba
       no protege en telefono. Si el cliente acaba de venir de /discount/, sea
       cual sea el modo guardado, ACABA de pedir su descuento: borrarselo en
       ese mismo instante seria justo lo contrario de lo que se busca.
       El camino real de prepago va a /checkout y ni siquiera pasa por una
       pagina del tema, pero esto cubre la variante que aterriza en el carro y
       cualquier otra que aparezca. */
    try {
      if (document.referrer && document.referrer.indexOf('/discount/') >= 0) { return; }
    } catch (e) {}

    fetch(raizR() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.cart_level_discount_applications) { return null; }
        var hay = false;
        for (var i = 0; i < c.cart_level_discount_applications.length; i++) {
          var t = c.cart_level_discount_applications[i];
          if (t && /PAGOAHORA/i.test(t.title || t.code || '')) { hay = true; }
        }
        if (!hay) { return null; }
        return fetch(raizR() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).then(function () {
          /* el resto del sitio tiene que enterarse de que las cifras cambiaron */
          try { document.dispatchEvent(new CustomEvent('rk:carro', { detail: { fuente: 'rk-cupon' } })); } catch (e) {}
        });
      })
      .catch(function () {});
  })();

  /* ---------- 5c. NINGUN BOTON PROMETE UNA CIFRA QUE NO VA A COBRAR ----------

     LO QUE PASABA. Con algo ya en el carro, los dos botones de la ficha
     seguian anunciando el precio de ESE producto. Medido: el boton decia
     "Con tarjeta, quedan $31.410" y el checkout abria con $56.520, porque
     cobra el carro entero. Diferencia de $25.110 justo en el salto a pagar.
     Lo mismo por contra entrega: prometia $34.900 y el formulario del carro
     cobraba $69.800.

     POR QUE SE QUITA LA CIFRA EN VEZ DE CORREGIRLA. Se podria calcular el
     total, pero seria un tercer sitio donde se calcula un precio, y el
     problema de fondo del embudo es justamente que la cifra que se promete y
     la que se cobra se calculan en sitios distintos y ninguno consulta al
     otro. Con el carro vacio, que es el caso corriente, la cifra sigue
     saliendo exacta desde Liquid y no se toca nada. Con el carro cargado se
     dice la verdad sin numero: la cifra exacta la ve en la pantalla
     siguiente, que es la unica que manda. */
  (function () {
    if (document.documentElement.hasAttribute('data-rk-solo')) { return; }
    if (!document.body || document.body.className.indexOf('rk-tpl-producto') < 0) { return; }
    var raizB = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };
    fetch(raizB() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) { return; }
        /* la variante de esta ficha: si el carro solo la trae a ella, la cifra
           de los botones sigue siendo la correcta y no hay nada que avisar */
        var esta = null;
        var bp = document.querySelector('[data-rk-cta="prepago"], [data-rk-cta="cod"]');
        if (bp) { esta = parseInt(bp.getAttribute('data-rk-var') || '0', 10); }
        var otras = 0;
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].variant_id !== esta) { otras++; }
        }
        if (!otras) { return; }

        var poner = function (sel, txt) {
          var nodos = document.querySelectorAll(sel);
          for (var k = 0; k < nodos.length; k++) {
            var s = nodos[k].querySelector('small');
            if (!s) { continue; }
            s.textContent = txt;
            /* se sueltan los textos que cambia el selector de pago: si se
               quedaran, el dock volveria a escribir la cifra vieja encima */
            s.removeAttribute('data-cod-t');
            s.removeAttribute('data-pre-t');
          }
        };
        poner('[data-rk-cta="cod"]', 'Tu pedido completo, pagas al recibir');
        poner('[data-rk-cta="prepago"]', 'Tu pedido completo, con 10% menos');
      })
      .catch(function () {});
  })();

  /* ---------- 6. SENAL DE QUE ALGO ESTA PASANDO ----------

     EL PROBLEMA. Los botones de compra no navegan al instante: el tema
     intercepta el clic, mira el carro, agrega si hace falta y recien
     entonces abre la oferta o el formulario. En un telefono eso puede
     tardar segundos, y durante ese rato la pantalla no cambiaba en nada.
     Para el cliente eso no se lee como "esta cargando", se lee como
     "esta roto": vuelve a pulsar, o se va. En contra entrega, donde la
     confianza es todo el negocio, un boton que no responde cuesta la venta
     entera.

     LA REGLA. Ningun boton de compra puede quedarse mudo. Al pulsarlo entra
     en estado de carga en el mismo cuadro: se apaga un poco, aparece un
     giro a su derecha y deja de aceptar clics. Eso ultimo tambien evita el
     doble toque, que es como se duplicaban unidades en el carro.

     CUANDO SE APAGA. Cuando el flujo llego a alguna parte: el carro
     cambio, la oferta se abrio, o la pagina se va. Y una red de seguridad
     a los 12 segundos, porque un boton girando para siempre miente peor
     que uno que no gira.

     Se cuelga de document en fase de captura para no depender de que
     ningun otro manejador deje pasar el evento. */
  (function () {
    /* La equis del modal NO entra aqui a proposito: es una salida, tiene que
       cerrar en el acto. El "No, gracias" si, porque sigue hacia el pago. */
    /* .rk-xs__acc entra el 02-09-2026 y sustituye a .rk-card__add, que llevaba
       aqui sin cubrir NADA: esa clase no existe en el tema, el boton rapido de
       la tarjeta se llama .rk-card__rapido y ya entraba por data-rk-agregar.

       .rk-xs__acc es el "+ Agregar" de la venta cruzada DENTRO del carro, y es
       un enlace pelado a /cart/add sin data-rk-agregar. Sin estado de carga
       tampoco tenia pointer-events:none, asi que el doble toque contaba dos
       veces: medido, dos clics separados 120 ms dejaron cantidad 2 y subtotal
       74.700 donde un solo clic deja 49.800. En un telefono el doble toque no
       es torpeza, es lo que hace cualquiera cuando la primera vez no parece
       pasar nada. Entrando aqui, el primer clic navega y el segundo ya no
       encuentra donde aterrizar. */
    var SEL = '[data-rk-cta],[data-rk-ir],.rk-riel__op,[data-rk-of-si],button.rk-of__no,[data-rk-agregar],.rk-xs__acc,[data-rk-var-op]';
    var CLASE = 'rk-cargando';
    var vivo = null, reloj = null;

    function apagar() {
      if (reloj) { clearTimeout(reloj); reloj = null; }
      if (!vivo) { return; }
      vivo.classList.remove(CLASE);
      vivo.removeAttribute('aria-busy');
      vivo = null;
    }
    function encender(el) {
      apagar();
      vivo = el;
      el.classList.add(CLASE);
      el.setAttribute('aria-busy', 'true');
      reloj = setTimeout(apagar, 12000);
    }

    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest(SEL) : null;
      if (!t || t.hasAttribute('disabled')) { return; }
      /* EL SEGUNDO TOQUE SE BLOQUEA DE VERDAD, no solo con CSS.
         Hasta ahora, un elemento que ya estaba cargando se ignoraba y se
         dejaba pasar: el bloqueo lo hacia pointer-events:none de la clase.
         Eso frena el dedo, pero NO frena una segunda activacion que no venga
         del puntero, y sobre todo no es una garantia, es un efecto lateral de
         una regla de estilo. Para algo cuyo fallo se mide en unidades cobradas
         de mas, la garantia tiene que estar en el manejador.
         Comprobado el 02-09-2026 en el "+ Agregar" de la venta cruzada del
         carro: dos activaciones seguidas dejaban el producto en cantidad 2. */
      /* SOLO SE BLOQUEA AL DEDO, NUNCA AL PROPIO TEMA.
         ev.isTrusted distingue un toque de verdad de un clic disparado por
         codigo, y esa diferencia es la que hace que esto funcione en vez de
         romperlo todo: rk-oferta.js intercepta el boton de compra, mira el
         carro y DESPUES vuelve a lanzar el mismo clic con b.click() para que
         siga su camino normal. Ese segundo clic llega con la clase de carga
         todavia puesta, asi que sin isTrusted el guardia lo tomaba por un
         doble toque y lo mataba: el formulario de contra entrega no se abria
         NUNCA en ningun producto. Reproducido en vivo el 02-09-2026, con los
         once campos del formulario en altura 0.
         Un dedo no puede producir un evento no confiable, asi que la
         proteccion contra el doble toque no pierde nada. */
      if (t.classList.contains(CLASE)) {
        if (ev.isTrusted) {
          ev.preventDefault();
          ev.stopPropagation();
        }
        return;
      }
      encender(t);
    }, true);

    /* el carro respondio */
    document.addEventListener('rk:carro', function () { setTimeout(apagar, 200); });
    /* la pagina se va: el estado se lo lleva la navegacion */
    window.addEventListener('pagehide', apagar);
    window.addEventListener('beforeunload', apagar);

    /* la oferta aparecio: el cliente ya tiene algo que mirar.
       Se vigila el atributo hidden del panel, que es un nodo que Liquid
       imprime una vez y nadie reemplaza, asi que el observador no se queda
       colgado de un elemento muerto. */
    var of = document.querySelector('[data-rk-of]');
    if (of && typeof MutationObserver === 'function') {
      new MutationObserver(function () { if (!of.hidden) { apagar(); } })
        .observe(of, { attributes: true, attributeFilter: ['hidden'] });
    }
    /* ======================================================================
       DOBLE TOQUE EN UN ENLACE QUE AGREGA NAVEGANDO

       POR QUE HACE FALTA APARTE. El estado de carga ya impide el doble toque
       en todo lo que NO navega. Pero el "+ Agregar" de la venta cruzada del
       carro es un enlace de verdad a /cart/add con return_to=/cart, y navega a
       proposito: en el carro hay que repintar la pagina para que la linea
       nueva aparezca, cosa que agregar por AJAX no haria.

       Y justo en ese caso el guardia se desarma solo. Al empezar la navegacion
       se dispara pagehide, pagehide llama a apagar(), apagar() quita la clase,
       y el segundo toque 120 ms despues ya no encuentra nada que lo frene.
       Medido: dos activaciones dejaban el producto en cantidad 2, subtotal
       74.700 donde con una queda en 49.800.

       Por eso la marca de "este ya se pulso" vive aqui, en una variable que
       nadie limpia, y no en la clase. Tres segundos: mas que suficiente para
       cubrir el viaje, y lo bastante corto para que quien de verdad quiera dos
       unidades pueda pedirlas.

       El alcance es SOLO este enlace, a proposito. Los demas botones de compra
       o no navegan o ya estan cubiertos, y una regla ancha sobre
       a[href*="/cart/add"] alcanzaria tambien al boton de prepago de la ficha,
       que rk-oferta.js intercepta para abrir la oferta: bloquearlo ahi seria
       apagar la venta cruzada por resolver un problema que ese boton no tiene.
       ====================================================================== */
    (function () {
      var ultimoNodo = null, ultimoEn = 0;
      document.addEventListener('click', function (ev) {
        var a = ev.target && ev.target.closest ? ev.target.closest('a.rk-xs__acc') : null;
        if (!a) { return; }
        var ahora = Date.now();
        if (a === ultimoNodo && (ahora - ultimoEn) < 3000) {
          ev.preventDefault();
          ev.stopPropagation();
          return;
        }
        ultimoNodo = a;
        ultimoEn = ahora;
      }, true);
    })();

    /* el formulario de contra entrega del carro aparecio */
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        var c = document.documentElement.classList;
        /* EL CARRO. Su formulario se monta en #cart-wrapper y avisa asi. */
        if (c.contains('rk-cod-carro-abierto') ||
            document.querySelector('.rk-cod-carro-abierto')) { apagar(); return; }
        /* LA FICHA, que faltaba, y faltaba en TODO EL CATALOGO MENOS UNO.
           Medido el 02-09-2026 en cuatro productos sin oferta: el formulario de
           contra entrega se revela a los 107 ms y el boton seguia girando hasta
           los 12.002 ms, o sea hasta la red de seguridad, sin que nada lo
           cortara. Doce segundos de giro sobre una pantalla lista para
           escribir, en el momento en que el cliente ya decidio comprar.

           Por que no se habia visto: la parrilla, que es donde siempre se
           probaba, es el UNICO producto con oferta, y ahi lo que apaga el giro
           es la apertura del modal. El unico caso especial del catalogo tapaba
           el comportamiento de los otros noventa y tantos.

           rk-cod-abierto la pone rk-ui.js al revelar el formulario, y ademas
           baja hasta el y enfoca el primer campo: cuando esta, no queda nada
           que esperar. */
        if (c.contains('rk-cod-abierto')) { apagar(); }
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  })();
})();
